import AppLayout from "@/layouts/AppLayout.vue";
import ReferralRewardListView from "@/views/referralReward/ReferralRewardListView.vue";
import ReferralRewardDetailView from "@/views/referralReward/ReferralRewardDetailView.vue";

export default [
  {
    path: '/referral-rewards',
    name: 'referralRewards',
    component: ReferralRewardListView,
    meta: {
      parent: 'referral',
      related: 'referralRewards',
      layout: AppLayout,
      requiresAuth: true,
      inNav: true,
      permissions: ['GET_REFERRAL_REWARD']
    }
  },
  {
    path: '/referral-rewards/:id',
    name: 'referralRewardDetail',
    component: ReferralRewardDetailView,
    meta: {
      parent: 'referral',
      related: 'referralRewards',
      layout: AppLayout,
      requiresAuth: true,
      inNav: false,
      permissions: ['GET_REFERRAL_REWARD']
    }
  },
];
